import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"
import Button from "react-bootstrap/Button"
import { FiInfo } from "react-icons/fi"

import useT from "utils/hooks/useT"
import Loading from "components/Loading"
import { AnalysisConfigurationPage } from "components/Config"
import { analysisDefinitions, analysisGroups } from "state_management"

// LIMS › read-only analysis definition (SPEC-058 B2, Plannertech-user#4115). A reviewer or
// supervisor about to approve a specification version should not sign blind; the definition page
// under Setup is the planner's and closed to members, so the SAME page is rendered here — inside
// an `inert` host, which blocks every click and focus in the editor — with the save/cancel bar
// hidden (ConfigContainer `disabled`). Everyone on a LIMS team may open it (SPEC-022 doctrine:
// everyone can SEE); the server refuses any write from a non-planner regardless.
//
// The definitions list is fetched here because a MEMBER never visits Setup, where it is normally
// loaded; the page itself loads the spec versions and documents it needs.
export default function AnalysisDefinitionReadOnly() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { analysisDefinitionId } = useParams()
  const definition = useSelector((state) => state.analysisDefinitions[analysisDefinitionId])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    dispatch(analysisDefinitions.fetch())
      .catch(() => {})
      .finally(() => setLoaded(true))
  }, [dispatch])

  useEffect(() => {
    // The page reads the active analysis group like the Setup wrapper sets it.
    dispatch(
      analysisGroups.changeActiveAnalysisGroupId(
        definition && definition.analysisGroupIds ? definition.analysisGroupIds[0] : null
      )
    )
  }, [dispatch, definition])

  const back = (
    <Button variant="link" onClick={() => navigate("/lims/change-control")}>
      {t("limsChangeControlBack")}
    </Button>
  )

  if (!definition) {
    return (
      <div className="AnalysisDefinitionReadOnly">
        <div className="AnalysisDefinitionReadOnly-banner">
          <FiInfo />
          <span>{loaded ? t("limsAnalysisDocNoAnalyses") : t("loading")}</span>
          {back}
        </div>
        {!loaded && <Loading />}
      </div>
    )
  }

  return (
    <div className="AnalysisDefinitionReadOnly">
      <div className="AnalysisDefinitionReadOnly-banner">
        <FiInfo />
        <span>{t("limsChangeControlReadOnlyBanner")}</span>
        {back}
      </div>
      <div className="AnalysisDefinitionReadOnly-body SetupScreen-item-config" inert>
        <AnalysisConfigurationPage id={analysisDefinitionId} readOnly />
      </div>
    </div>
  )
}
